import { CUSTOMER_METHODS_PLACE_BETS} from './actionTypes'

export const clickedOdds = ( data: any ) => ({
    type: CUSTOMER_METHODS_PLACE_BETS,
    data,
})
